import { useTheme } from "@emotion/react";
import { Cancel } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Divider, Box, Paper } from "@mui/material";
import React, { useContext } from "react";
import { Fragment } from "react";
import Draggable from "react-draggable";
import BSSDataContext from "../../contexts/BSSDataContext";
import useBSSLogger from "../../hooks/useBSSLogger";
import __t from "../../lib/traduzioni";

const {logger} = useBSSLogger();

const BSSDialog = ({children, ...DialogProps}) => {

    const {shadowBody} = useContext(BSSDataContext);

    DialogProps = {...{
        container: shadowBody,
    }, ...DialogProps}

    //logger.debug("bss drawer props ", DrawerProps, shadowBody)

    return (
        <>
            <Dialog {...DialogProps}>
                {children}
            </Dialog>
        </>
    )
}

const defaultCloseBtnProps = {autoFocus: true, variant: "contained" };
const defaultConfirmBtnProps = {variant: "contained", color: "primary" }

const BSSConfirmDialog = ({
    children, 
    confirmAction, 
    undoAction, 
    closeHandler = null, 
    title = null,     
    closeBtnProps = defaultCloseBtnProps,
    confirmBtnProps = defaultCloseBtnProps,
    ...DialogProps
}) => {

    if([undefined, null].includes(closeHandler)){ 
        closeHandler = undoAction
    }
    
    return (
        <BSSDialogWithActions {...{closeHandler, title, ...DialogProps}} actions={[(
            <>
                <Button key="btn_annulla" color="secondary"  onClick={undoAction} {...{...defaultCloseBtnProps, ...closeBtnProps}}>
                    {closeBtnProps?.label ?? __t("annulla")}
                </Button>
                <Button key="btn_conferma" onClick={confirmAction} {...{...defaultConfirmBtnProps, ...confirmBtnProps}}>
                    {confirmBtnProps?.label ?? __t("conferma")}
                </Button>
            </>
        )]}>
            {children}
        </BSSDialogWithActions>  
    )
}

const BSSDialogWithActions = ({
    children, 
    actions = null,
    closeHandler = null, 
    title = null,     
    draggable = false,
    ...DialogProps
}) => {

    const props = {
        style: {zIndex: 10000},
        onClose: closeHandler,
        PaperComponent: (props) => {
            return (
                <Draggable disabled={!draggable} handle={".draggableDialogHandler"}  cancel={'[class*="MuiDialogContent-root"]'}>
                    <Paper {...props} />
                </Draggable>
            )
        },
        ...DialogProps
    }

    return (
        
            <BSSDialog {...props}>
                
                {title !== null && (
                    <>
                        
                        <DialogTitle className={"draggableDialogHandler"}>
                            <Box display="flex">
                                <Box flexGrow={1}>
                                    {title}
                                </Box> 
                                <Box pl={2}>
                                    <Cancel sx={{cursor: "pointer"}} onClick={closeHandler} />
                                </Box>
                            </Box>
                            
                        </DialogTitle>


                        <Divider />

                    </>
                )}
                
                <DialogContent>
                    {children}
                </DialogContent>


                {actions !== null && (Array.isArray(actions) &&  actions.length > 0) && (
                    <>

                        <Divider />
                        
                        <DialogActions>
                            {actions}
                        </DialogActions>
                    </>
                )}
                

            </BSSDialog>
    )
}


export default BSSDialog
export {BSSConfirmDialog, BSSDialogWithActions}